import { s as size, g as getSizePresetFromNextTokens } from '../../dist/text-76e6f14c.esm.js';
export { c as buttonColor, e as buttonEqualSizes, f as buttonFill, a as buttonShape, b as buttonShapeEqual, d as buttonSize, h as buttonSizes, i as checkboxSize, i as controlSize, j as headingSize, c as iconButtonColor, f as iconButtonFill, b as iconButtonShape, d as iconButtonSize, s as iconSize, k as listSize, l as loaderSizes, m as progressSize, v as progressVariant, i as radioSize, i as sliderSize, n as tabSize, o as textSize } from '../../dist/text-76e6f14c.esm.js';
export { g as colors, a as headingAliases, c as headingCapsizes, p as headingPresets, s as headingSizes, r as radii, b as textAliases, f as textCapsizes, e as textPresets, d as textSizes } from '../../dist/radii-300ca920.esm.js';
import { fromEntries } from '@hover/utilities';
import '@hover/tokens-depth';
export { p as borderPreset, a as borderPresets, b as borderWidths, c as breakpoints, h as colorHues, n as colorHuesNeutral, d as colorPalettes, s as colorSchemes, e as colorSchemesBrand, f as colorSchemesNeutral, g as colorSchemesProduct, m as motion, i as shadows } from '../../dist/shadows-2f16f0de.esm.js';
import '@hover/tokens-border';
import '@hover/tokens-size';
import '@hover/tokens-space';
import '@hover/tokens-typography';
import * as tokens$1 from '@hover/tokens-size/next';
import * as tokens$2 from '@hover/tokens-space/next';
import * as tokens$3 from '@hover/tokens-typography/next';
import * as tokens from '@hover/tokens-color';
export { tokens as colorTokens };
import '../../dist/unsupportedIterableToArray-d4b21e24.esm.js';
import 'ramda/src/pick';
import 'ramda/src/map';
import '@hover/tokens-typography/assets/capsizes.json';
import '@hover/tokens-typography/assets/capsizes.next.json';
import '@hover/tokens-color/next';
import '@hover/tokens-border/next';
import '@hover/tokens-device';
import '@hover/tokens-motion';

// TODO(default-size): deprecate `default` size in all size maps and export
// member from `size` (e.g: `export defaultSize = 'small'`) tuple instead (to
// be passed as `defaultProp` in Chakra, for example)
var sizes$1 = /*#__PURE__*/fromEntries( /*#__PURE__*/size.map(function (s) {
  return [s, getSizePresetFromNextTokens('Icon', s === 'default' ? 'small' : s)];
}));

var sizes = {
  25: tokens$1.size25,
  50: tokens$1.size50,
  75: tokens$1.size75,
  100: tokens$1.size100,
  200: tokens$1.size200,
  250: tokens$1.size250,
  300: tokens$1.size300,
  350: tokens$1.size350,
  375: tokens$1.size375,
  400: tokens$1.size400,
  500: tokens$1.size500,
  600: tokens$1.size600,
  700: tokens$1.size700,
  750: tokens$1.size750,
  800: tokens$1.size800,
  850: tokens$1.size850,
  900: tokens$1.size900,
  checkbox: {
    small: tokens$1.sizeCheckboxSmall,
    medium: tokens$1.sizeCheckboxMedium,
    large: tokens$1.sizeCheckboxLarge
  },
  radio: {
    small: tokens$1.sizeRadioSmall,
    medium: tokens$1.sizeRadioMedium,
    large: tokens$1.sizeRadioLarge
  }
};

var space = {
  0: tokens$2.size0,
  50: tokens$2.size50,
  100: tokens$2.size100,
  200: tokens$2.size200,
  300: tokens$2.size300,
  400: tokens$2.size400,
  500: tokens$2.size500,
  600: tokens$2.size600,
  700: tokens$2.size700,
  800: tokens$2.size800,
  900: tokens$2.size900,
  1000: tokens$2.size1000,
  1100: tokens$2.size1100
};

var typography = {
  fonts: {
    body: tokens$3.familyBody,
    brand: tokens$3.familyBrand,
    code: tokens$3.familyCode,
    display: tokens$3.familyDisplay
  },
  lineHeights: {
    50: tokens$3.height50,
    100: tokens$3.height100,
    200: tokens$3.height200,
    300: tokens$3.height300,
    400: tokens$3.height400,
    500: tokens$3.height500,
    600: tokens$3.height600,
    700: tokens$3.height700,
    800: tokens$3.height800,
    900: tokens$3.height900,
    1000: tokens$3.height1000
  },
  fontWeights: {
    100: tokens$3.weight100,
    300: tokens$3.weight300,
    400: tokens$3.weight400,
    500: tokens$3.weight500,
    600: tokens$3.weight600,
    700: tokens$3.weight700,
    body: tokens$3.weightBody,
    bodyBold: tokens$3.weightBodyBold,
    bodySemiBold: tokens$3.weightBodySemiBold,
    bodyMedium: tokens$3.weightBodyMedium,
    display: tokens$3.weightDisplay,
    heading: tokens$3.weightHeading,
    headingLight: tokens$3.weightHeadingLight
  },
  fontSizes: {
    50: tokens$3.size50,
    100: tokens$3.size100,
    200: tokens$3.size200,
    300: tokens$3.size300,
    400: tokens$3.size400,
    500: tokens$3.size500,
    600: tokens$3.size600,
    700: tokens$3.size700,
    800: tokens$3.size800,
    900: tokens$3.size900,
    1000: tokens$3.size1000,
    base: tokens$3.sizeBase
  },
  letterSpacings: {
    200: tokens$3.spacing200,
    300: tokens$3.spacing300,
    400: tokens$3.spacing400,
    500: tokens$3.spacing500,
    base: tokens$3.spacingBase
  }
};

export { sizes$1 as iconSizes, sizes, space, typography };
